import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";
import { isValid as isOutcomeTypeValid } from "@/constants/OutcomeType";

export class TopicOutcomeEditedEvent extends AmplitudeEvent {
	constructor( meetingId, outcomeType ) {
		if ( !isOutcomeTypeValid( outcomeType ) ) {
			throw new Error( `outcome type is not valid: ${outcomeType}` );
		}
		super();
		this.name = "Topic Outcome Edited";
		this.eventProperties.meeting_id = meetingId;
		this.eventProperties.outcome_type = outcomeType;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/TopicOutcomeEditedEvent.js